import mixpanel from 'mixpanel-browser'

const EVENT_NAME = 'CoronaSubmit'

export default function trackSubmit() {
  mixpanel.track(EVENT_NAME)
}
